// services/api/adminApi.js
import axiosInstance from "utils/axiosInstance";

const adminApi = {
  /**
   * Fetches dashboard summary data
   * @returns {Promise<Object>} A promise that resolves to the dashboard summary data
   */
  getDashboardSummary: async () => {
    const response = await axiosInstance.get("admin/dashboard/dashboard-summary");
    return response?.data?.data || {};
  },

  /**
   * Fetches all employees data
   * @returns {Promise<Array>} A promise that resolves to an array of employee objects
   */
  getEmployees: async () => {
    const response = await axiosInstance.get("/employee/getall");
    return response?.data?.data?.employees || [];
  },

  /**
   * Fetches attendance records
   * @returns {Promise<Object>} A promise that resolves to the attendance data
   */
  getAttendance: async () => {
    const response = await axiosInstance.get("/attendance/getall");
    return response?.data || {};
  },
  exportAdminsCSV: async () => {
    const response = await axiosInstance.get("/admin/export/csv", {
      responseType: "blob",
    });
    return response.data;
  },
  bulkDeleteAdmins: async (adminIds) => {
    const response = await axiosInstance.delete("/admin/bulk/delete", {
      data: { admin_ids: adminIds },
    });
    return response.data;
  },
  bulkDeactivateAdmins: async (adminIds) => {
    const response = await axiosInstance.put("/admin/bulk/deactivate", {
      admin_ids: adminIds,
    });
    return response.data;
  },
  bulkActivateAdmins: async (adminIds) => {
    const response = await axiosInstance.put("/admin/bulk/activate", {
      admin_ids: adminIds,
    });
    return response.data;
  },
  deleteAdmin: async (adminId) => {
    const response = await axiosInstance.delete(`/admin/delete/${adminId}`);
    return response.data;
  },
  updateAdmin: async (adminId, adminData) => {
    const response = await axiosInstance.put(`/admin/update/${adminId}`, adminData);
    return response.data;
  },
  getRoles: async () => {
    const response = await axiosInstance.get("/roles");
    return response.data || [];
  },

  /**
   * Creates a new admin user
   * @param {Object} adminData - The admin data to create
   * @returns {Promise<Object>} A promise that resolves to the created admin object
   */
  createAdmin: async (adminData) => {
    const response = await axiosInstance.post("/admin/create", adminData);
    return response.data;
  },
  getAdmins: async () => {
    const response = await axiosInstance.get("/admin/getall-admins");
    return response.data.admins || [];
  },
};

export default adminApi;